import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services-banner',
  templateUrl: './services-banner.component.html',
  styleUrls: ['./services-banner.component.scss'],
})
export class ServicesBannerComponent implements OnInit {
  public servicesBanner = [
    {
      icon: 'fire-off.svg',
      title: 'Emergencias Químicas',
      desc:
        // tslint:disable-next-line:max-line-length
        'Brindamos respuesta con personal y equipamiento especializado en el lugar del incidente/ accidente ante emergencias con materiales peligrosos, las 24 horas los 365 días del año.',
      btn: 'Ver más',
    },
    {
      icon: 'contract.svg',
      title: 'Capacitaciones',
      desc:
        // tslint:disable-next-line:max-line-length
        'Brindamos capacitación especializada acorde a las necesidades de cada cliente. Nuestro servicio se encuentra Certificado bajo ISO 9001.',
      btn: 'Ver más',
    },
    {
      icon: 'danger.svg',
      title: 'Gestión de riesgos',
      // tslint:disable-next-line:max-line-length
      desc:
        'Ofrecemos asesoramiento y gestión de riesgo químico, ambiental y toxicológico.',
      btn: 'Ver más',
    },
    {
      icon: 'mask.svg',
      title: 'Trabajos de alto riesgo',
      // tslint:disable-next-line:max-line-length
      desc:
        'Brindamos soluciones para todo tipo de trabajos de alto riesgo que involucren materiales peligrosos.',
      btn: 'Ver más',
    },
  ];

  constructor() {}

  ngOnInit() {}
}
